class GameCard{
    constructor(isLucky) {
        this.isLucky = isLucky;
    }
}

export default GameCard;